module.exports = __webpack_public_path__ + "img/DE05912.b82c3538.png";